export default class PreLoadImpController {
    constructor({
                    track = () => {},
                    resumedCallback,
                    pausedCallback
                }) {
        this.preLoadImpQueue = []; // 预加载曝光队列
        this.track = track; //曝光函数实现
        this.trackPreLoadImp = this.trackPreLoadImp.bind(this)
        // 监听resume事件，更新pageState，曝光preLoadImpQueue中事件并清空
        window.PPDWebUI && window.PPDWebUI.ListenerService.resumeListener(() => {
            this.pageState = 'resumed'
            this.clearPreloadQueue();
            resumedCallback && resumedCallback();
        })
        // 监听pause事件，更新pageState，清空scrollImpArray和exposureScrollArray
        window.PPDWebUI && window.PPDWebUI.ListenerService.pauseListener(() => {
            this.pageState = 'paused'
            pausedCallback && pausedCallback();
        })
    }

    clearPreloadQueue() {
        let  _preLoadImpQueue = []
        while(this.preLoadImpQueue.length){
            let item = this.preLoadImpQueue.splice(0, 1)[0];
            this.H5ShowVisible().then(res => {
                if(res) {
                    this.track(item.params);
                }
            })
            if(item.eventParams && item.eventParams.rePreloadImp){
                _preLoadImpQueue.push(item)
            }
        }
        this.preLoadImpQueue = _preLoadImpQueue;
    }

    // Service: H5VisibleService
    // 方法：isVisible（）
    // 字段：visible：true 曝光，false 未曝光
    H5ShowVisible() {
        return new Promise((resolve, reject) => {
            if(window.PPDWebUI && window.PPDWebUI.H5VisibleService){
                window.PPDWebUI.H5VisibleService.isVisible((res)=>{
                    if(res.visible){
                        resolve(true);
                    }else{
                        setTimeout(()=>{
                            window.PPDWebUI.H5VisibleService.isVisible((res)=>{
                                if(res.visible){
                                    resolve(true);
                                } else {
                                    resolve(false);
                                }
                            })
                        }, 200);
                    }
                },()=>{
                    return reject(true);
                })
            }else{
                return reject(true);
            }
        })
    }

    trackPreLoadImp(eventType,params,eventParams){
        if(window.PPDWebUI && window.PPDWebUI.H5VisibleService){
            window.PPDWebUI.H5VisibleService.isVisible((res)=>{
                if(res.visible){
                    this.track(params);
                    if(eventParams && eventParams.rePreloadImp) {
                        this.preLoadImpQueue.push({
                            eventType,
                            params,
                            eventParams
                        })
                    }
                }else{
                    this.preLoadImpQueue.push({
                        eventType,
                        params,
                        eventParams
                    })
                    setTimeout(()=>{
                        window.PPDWebUI.H5VisibleService.isVisible((res)=>{
                            if(res.visible){
                                this.clearPreloadQueue();
                            }
                        })
                    }, 200);
                }
            },()=>{
                this.preLoadImpQueue.push({
                    eventType,
                    params,
                    eventParams
                })
            })
        }else{
            this.preLoadImpQueue.push({
                eventType,
                params,
                eventParams
            })
        }
    }
}
